import React from 'react';
import { Box } from '@chakra-ui/react';
import { GlassPageBg } from '../../../components/glass';
import { FinanceiroPageHeader } from '../financeiro/components/FinanceiroPageHeader';
import { AUDITORIA_BASE } from './useAuditoriaContext';

interface AuditoriaShellProps {
  eyebrow?: string;
  titulo: string;
  subtitulo?: string;
  icon: React.ReactNode;
  cor: string;
  info?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Casca de cada submódulo da Auditoria Inteligente — espelha o padrão do
 * Financeiro: fundo glass + cabeçalho de página (eyebrow/título/ícone/voltar).
 * A topbar de contexto (empresa/período) NÃO vive aqui: é global do módulo,
 * renderizada pelo Layout (ver AuditoriaTopbar). O corpo (children) é a tela.
 */
export function AuditoriaShell({
  eyebrow,
  titulo,
  subtitulo,
  icon,
  cor,
  info,
  actions,
  children,
}: AuditoriaShellProps) {
  return (
    <GlassPageBg>
      <Box maxW="1320px" mx="auto" w="full" px={{ base: 4, md: 8 }} py={{ base: 5, md: 8 }}>
        <FinanceiroPageHeader
          eyebrow={eyebrow}
          titulo={titulo}
          subtitulo={subtitulo}
          icon={icon}
          cor={cor}
          info={info}
          actions={actions}
          backTo={AUDITORIA_BASE}
        />
        {children}
      </Box>
    </GlassPageBg>
  );
}
